import React from 'react';
import { Button, type ButtonProps } from '@naf-simba/elements-buttons';
import { mapSimbaVariant, type LegacyButtonVariant } from '@utils/simba';
import { MEMBERPAGES_URL } from '@lib/constants';
import { useTrackCTA } from '../../../utils/Tracking/CtaClick/TrackCtaClick';
import { useLoginRedirect } from '../../../hooks/useLoginRedirect';

type Props = {
  buttonText?: string;
  returnUrl?: string;
  variant?: LegacyButtonVariant;
} & Pick<ButtonProps, 'sx'>;

export const LoginButton = ({ buttonText, returnUrl, variant: legacyVariant, sx }: Props) => {
  const returnToUrl = returnUrl || `/${MEMBERPAGES_URL}`;
  const trackCTA = useTrackCTA();
  const { redirectToLoginPage } = useLoginRedirect();
  const { color, variant } = mapSimbaVariant(legacyVariant);

  const text = buttonText || 'Logg inn';

  return (
    <Button
      color={color}
      variant={variant}
      onClick={() => {
        trackCTA({ cta_position: 'content', text });
        redirectToLoginPage(returnToUrl);
      }}
      sx={sx}
    >
      {text}
    </Button>
  );
};
